import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'
import classnames from 'classnames'

import {
  Button as ButtonComponent,
  BadgeComponent,
} from '../../../../components'
import useFeatures from '../../../../hooks/useFeatures'

import { JoinToSpeakBadgeFeature } from './join-to-speak-badge'

import './WebinarSidebarActionButtonsComponent.scss'

const WebinarSidebarActionButtonsComponent = (props) => {
  const {
    isAssociatedWebinar,
    onActivityClick,
    onWebinarsClick,
    onPollsClick,
    onQuestionsClick,
    onHandoutsClick,
    onPeopleClick,
    unreadQuestionsCount,
    accentColor,
    currentlySelectedSecondaryPanel,
  } = props

  const { HasJoinToSpeakEnabled } = useFeatures()

  const chatButtonLabel = intl.formatMessage({ defaultMessage: 'Chat' })

  return (
    <div className="webinar-sidebar-action-buttons-component">
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel': !currentlySelectedSecondaryPanel,
        })}
      >
        <ButtonComponent
          onClick={onActivityClick}
          color="transparent"
          className="action-button activity"
          ariaLabel={chatButtonLabel}
          size="small"
        >
          {chatButtonLabel}
        </ButtonComponent>
      </div>

      {isAssociatedWebinar && (
        <div
          className={classnames('button-wrapper', {
            'selected-secondary-panel':
              currentlySelectedSecondaryPanel === 'sessions',
          })}
        >
          <ButtonComponent
            onClick={
              currentlySelectedSecondaryPanel !== 'sessions'
                ? onWebinarsClick
                : undefined
            }
            color="transparent"
            className="action-button"
            ariaLabel={intl.formatMessage({
              defaultMessage: 'Webinars',
            })}
            size="small"
          >
            <FormattedMessage defaultMessage="Webinars" />
          </ButtonComponent>
        </div>
      )}

      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'polls',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'polls'
              ? onPollsClick
              : undefined
          }
          color="transparent"
          className="action-button polls"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'Polls',
          })}
          size="small"
        >
          <FormattedMessage defaultMessage="Polls" />
        </ButtonComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'questions',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'questions'
              ? onQuestionsClick
              : undefined
          }
          color="transparent"
          className="action-button questions"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'Questions',
          })}
          size="small"
        >
          <BadgeComponent color={accentColor} count={unreadQuestionsCount}>
            <FormattedMessage defaultMessage="Questions" />
          </BadgeComponent>
        </ButtonComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'handouts',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'handouts'
              ? onHandoutsClick
              : undefined
          }
          color="transparent"
          className="action-button"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'Handouts',
          })}
          size="small"
        >
          <FormattedMessage defaultMessage="Handouts" />
        </ButtonComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'people',
        })}
      >
        <ButtonComponent
          onClick={
            currentlySelectedSecondaryPanel !== 'people'
              ? onPeopleClick
              : undefined
          }
          color="transparent"
          className="action-button people"
          ariaLabel={intl.formatMessage({
            defaultMessage: 'People',
          })}
          size="small"
        >
          <JoinToSpeakBadgeFeature
            isEnabled={HasJoinToSpeakEnabled}
            color={accentColor}
          >
            <FormattedMessage defaultMessage="People" />
          </JoinToSpeakBadgeFeature>
        </ButtonComponent>
      </div>
    </div>
  )
}

WebinarSidebarActionButtonsComponent.propTypes = {
  isAssociatedWebinar: PropTypes.bool,
  onActivityClick: PropTypes.func,
  onWebinarsClick: PropTypes.func,
  onPollsClick: PropTypes.func,
  onQuestionsClick: PropTypes.func,
  onHandoutsClick: PropTypes.func,
  onPeopleClick: PropTypes.func,
  unreadQuestionsCount: PropTypes.number,
  accentColor: PropTypes.string,
  currentlySelectedSecondaryPanel: PropTypes.oneOf([
    'polls',
    'questions',
    'people',
    'handouts',
    'sessions',
    'playback',
  ]),
}

export default WebinarSidebarActionButtonsComponent
